import React, { ReactNode } from 'react';
import { getAreaComponents, ComponentDef } from '@/utilities/functions/magnoliaUtils';
import { Accordion } from 'br2s-ui-componentlibrary_r2_02';
import Richtext from '../Richtext/Richtext';
import './AccordionAdapter.scss'

export interface AccordionProps {
  id: string,
  /**
   * Accordion items
   */
  items: AccordionItemDef[];
  /**
   * Position of the expand & collapse all button
   */
  helperButtonPosition?: 'top' | 'bottom' | 'both' | 'none';
  /**
   * Accordion footer elements
   */
  accordionFooter?: ReactNode,
  initialExpandStatus?: boolean
}

interface AccordionItemDef extends ComponentDef {
  headerTitle: string;
  headerPrefix?: ReactNode;
  headerIconClassName?: string;
  headerMetadata?: string;
  headerTag?: {
    label: string,
    status?: 'default' | 'green' | 'maroon'
  }
  isForm?: boolean,
  children?: ReactNode;
  isDefaultExpanded?: boolean,
  subItems?: {
    headerTitle: string;
    headerIconClassName?: string;
    children: ReactNode;
    isDefaultExpanded?: boolean,
  }[],
  subItemsFooter?: ReactNode
}

function AccordionAdaptor({
    id,
    items = [],
    helperButtonPosition = 'top',
    initialExpandStatus = false
  }: AccordionProps) {

  const accordionItems = getAreaComponents(items)

  const prepareItems = (items: any) => {
      if (!items.length) return
      return items.map((item: any, i: number) => {

          //Level 2 data - no subitem
          const subItemNodes = typeof item.subItems !== 'undefined' ? getAreaComponents(item.subItems) : []

          const itemNode: any = {
              headerTitle: item.headerTitle ? item.headerTitle : '',
              headerIconClassName: item.headerIconClassName,
              isDefaultExpanded: item.isDefaultExpanded,
              children: <Richtext content={item.content} />
          }

          if (subItemNodes.length) {
              itemNode.subItems = prepareItems(subItemNodes)
          } else {
              //Meta on parent item only
              itemNode.headerMetadata = item.headerMetadata ? item.headerMetadata : ''
          }

          return itemNode
      })
  }

  const allItems = prepareItems(accordionItems)

  return (
    <Accordion
      id={id}
      items={allItems}
      helperButtonPosition={helperButtonPosition}
    />
  )
}

export default AccordionAdaptor;
